import Size from './Size';

export interface Resolution extends Size {
  name: string;
}

export function instanceOfResolution(object: any): object is Resolution {
  return (
    typeof object !== 'string' &&
    'name' in object &&
    'width' in object &&
    'height' in object
  );
}

export const SOCIAL_MEDIA_POST: Resolution = {
  name: 'Social media square',
  width: 1080,
  height: 1080
};

const SOCIAL_MEDIA_POST_VERTICAL: Resolution = {
  name: 'Social media vertical',
  width: 1080,
  height: 1350
};

const INSTAGRAM_STORY: Resolution = {
  name: 'Instagram story',
  width: 1080,
  height: 1920
};
// export const INSTAGRAM_STORY_LOW = new Resolution(
//   'Instagram story (low-res)',
//   720,
//   1280,
// );
const FACEBOOK_EVENT: Resolution = {
  name: 'Facebook event',
  width: 1280,
  height: 720
};
const FACEBOOK_COVER: Resolution = {
  name: 'Facebook cover',
  width: 820,
  height: 312
};
const STANDARD_HD: Resolution = {
  name: 'Standard HD',
  width: 1920,
  height: 1080
};

export const STANDARDS: Resolution[] = [
  INSTAGRAM_STORY,
  SOCIAL_MEDIA_POST_VERTICAL,
  SOCIAL_MEDIA_POST,
  FACEBOOK_EVENT,
  FACEBOOK_COVER,
  STANDARD_HD
];

export const matchResolutionWithStandards = (
  resolution: Resolution
): Resolution | null => {
  for (const r of STANDARDS) {
    if (r.width === resolution.width && r.height === resolution.height) {
      return r;
    }
  }
  return null;
};

export const isStandardResolution = (resolution: Resolution): Boolean => {
  const sr = matchResolutionWithStandards(resolution);
  return sr !== null;
};



// WEBPACK FOOTER //
// ./src/data/Resolution.ts